import i18n from 'i18next'

// Non-React module called from services/handlers with no component context,
// so `useTranslation` isn't available. Call `i18n.t()` directly; i18n is
// already initialized at app bootstrap.
const excludedMessages = [/login required/i, /Network error/i]

const ErrorHandler = (error, extra?) => {
  const errorMessage =
    (error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].message) ||
    (error.networkError && error.networkError.error_description) ||
    error.message ||
    'Unknown error'
  const message: string = i18n.t('errors.generic_retry', { ns: 'common' })

  for (const excludedMessage of excludedMessages) {
    if (excludedMessage.test(errorMessage) || excludedMessage.test(error.message)) {
      return { message, errorMessage }
    }
  }

  console.error('ErrorHandler', error, message, extra)

  return { message, errorMessage }
}

export default ErrorHandler
